

function Cancel() {
    return (
        <h1>Stripe payment has been cancelled!</h1>
    );
};

export default Cancel;